import { useMemo } from 'react';

import { Icon } from '@/icon';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/ui/DropdownMenu';

interface Option {
  label: string;
  value: string;
}

interface Props {
  selectedValue?: string;
  options: Option[];
  onChange: (value: string) => void;
}

export const PauseDurationDropdown = ({ selectedValue, options, onChange }: Props) => {
  const selectedOption = useMemo(() => {
    return options.find(({ value }) => value === selectedValue);
  }, [options, selectedValue]);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <button
          type="button"
          className="flex items-center justify-between w-full px-3 py-2 text-sm text-left bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 isolate"
        >
          <span className="text-gray-900 text-sm leading-5 font-normal">
            {selectedOption?.label || 'Select an option'}
          </span>
          <Icon name="CaretUpDown" type="caret-up-down" className="w-4 h-4 ml-2 text-gray-900 z-10" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent sideOffset={8}>
        {options?.map((option) => (
          <DropdownMenuItem key={option.value} onSelect={() => onChange(option.value)} className="w-full">
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
